module.exports = __webpack_public_path__ + "static/img/Bachelor_010697.ad93371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010697.jpg
// module id = 223
// module chunks = 0